
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mesonet-climate/graphs",
      function () {
        return require("private-next-pages/mesonet-climate/graphs.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mesonet-climate/graphs"])
      });
    }
  